import request from '@/utils/request';

// 获取商品可用优惠券数量
export function getCouponCount(data) {
  return request({
    url: '/activity/front/omo/coupon/getCanUseNum',
    method: 'post',
    data
  });
}

// 获取商品可用优惠券列表
export function getCanUseCouponList(data) {
  return request({
    url: '/activity/front/omo/coupon/getCanUseList',
    method: 'post',
    data
  });
}

// 获取商品不可用优惠券列表
export function getCannotUseCouponList(data) {
  return request({
    url: '/activity/front/omo/coupon/getNotCanUseList',
    method: 'post',
    data
  });
}

// 获取我的优惠券列表
export function getMyCouponList(type, params) {
  return request({
    url: `/activity/front/coupon/list/h5AndClient/${type}`,
    method: 'get',
    params
  });
}

// 兑换优惠券
export function exchangeCoupon(couponCode) {
  return request({
    url: `/activity/front/coupon/exchange/h5AndClient/${couponCode}`,
    method: 'get'
  });
}

// 获取优惠券可用列表
export function getCouponProductList(couponId, params) {
  return request({
    url: `/activity/front/coupon/list/h5AndClient/range/${couponId}`,
    method: 'get',
    params
  });
}

// 获取优惠券详情
export function getCouponDetail(couponId) {
  return request({
    url: `/activity/front/coupon/list/h5AndClient/getCouponInfoById/${couponId}`,
    method: 'get'
  });
}




// WEBPACK FOOTER //
// ./src/api/coupon/index.js